import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import spartaTemplates from "modules/community/loading-animation-module/4.1.0/js/templates";
import "css!modules/community/loading-animation-module/4.1.0/css/loading-animation-module.scss.css";
import "css!modules/community/loading-animation-module/4.1.0/css/loading-animation-content-based.scss.css";
/*
 * loading-animation-module
 * module_js_id: loadingAnimationModuleJS
 *
 * Copyright (c) 2011-1-9 Joshua Smith
 * Updated - 2018-04-25 Jay Wolfe
 */

/**
 * @class loadingAnimationModuleJS
 * @desc  loading animation module
 * @returns {Object} isntance of modal
 */
export default class LoadingAnimationModuleJS extends Module {
  /**
   * @function constructor
   * @desc  constructor
   * @param {Object} options options for the modal instance
   * @returns {Object} instance
   */
  constructor(options) {
    super(options);
    // can pass in removal events in an array
    this.removalEventArray = this.params.removalEvents; // (`${this.settings.removalEvent}.cancelProgressIndicator`).split('.');
    this.beginEventArray = this.params.beginEvents; // .split('.');
    const { querySection, querySectionTarget } = this.params;
    // the modules that are currently set to visibility hidden
    this.queuedModules = [...document.querySelectorAll(`${querySection} ${querySectionTarget}`)];
    // LOCAL ONLY will remove the progress indicator even if the ajax calls fail
    // DO NOT COMMIT UNCOMMENTED
    // this.allowLocalBypass(querySection, querySectionTarget);

    this.loaderWrapper = this.settings.target.querySelector('.loader-container-wrapper');
  }
  /**
   * @function init
   * @desc  standard sparta init - manipulates page for loading animation
   * @param {Object} args defaults to {}
   * @returns {returnType} returnTypeDescription
   */
  init(args = {}) { // eslint-disable-line
    // sets up removal event subscriptions
    this.setupRemovalEvents();
    // sets up watchers for "loading begin" events
    this.setupLoaderSubscriptions();
    // unhide all if initally should be hidden on page load
    // trigger any first removal event
    if (this.params.initiallyHidden) {
      this.removeLoader();
    }
    return this;
  }
  /**
   * @function setupRemovalEvents
   * @desc  sets up events to watch for to hide loader
   * specified in page config
   * @returns {void} undefined
   */
  setupRemovalEvents() {
    this.removalEventArray.forEach((removalEvent) => {
      this.Events.sub(removalEvent, () => {
        // adds removal to end of thread
        setTimeout(this.removeLoader.bind(this));
      }, true);
    });
  }

  /**
   * @function removeLoader
   * @desc  hide loader
   * @returns {void} undefined
   */
  removeLoader() {
    this.queuedModules.forEach(section => section.classList.add('loaded'));
    // moves the focus to the top of the page for ADA
    $('body').focus();
    // unhide wrapper if it was initially hidden on page load with initiallyHidden param
    if (this.loaderWrapper.classList.contains('hide')) {
      this.loaderWrapper.classList.remove('hide');
    }
  }
  /**
   * @function setupLoaderSubscriptions
   * @desc  setup for subscriptions to loading animation start
   * specified in page config
   * @returns {void} undefined
   */
  setupLoaderSubscriptions() {
    this.beginEventArray.forEach((beginEvent) => {
      this.Events.sub(beginEvent, () => {
        this.queuedModules.forEach(section => section.classList.remove('loaded'));
        // this.queuedModules.removeClass('loaded');
        // moves the focus to the top of the page for ADA
        $('body').focus();
      }, true);
    });
  }
  /**
   * @function allowLocalBypass
   * @desc  allows testing/development of loading situations locally
   * @param {string} querySection main selector for nodes hidden by loader
   * @param {string} querySectionTarget inner selector for specific nodes to hide
   * @returns {void} undefined
   */
  allowLocalBypass(querySection, querySectionTarget) {
    if (spartaStoreUtility.getData('environment') === 'LOCAL') {
      $(document).ajaxStop(() => {
        this.queuedModules = [...document.querySelectorAll(`${querySection} ${querySectionTarget}:not(.loaded)`)];
        if (this.queuedModules.length) {
          console.error('proper removalEvent did not fire');
          this.queuedModules.forEach(section => section.classList.add('loaded'));
        }
      });
    }
  }
}
